import React, { useContext, useState, useEffect } from "react";
import { Stack, Label, TextField } from "@fluentui/react";
import { SLLoadingStatus, leftPadDocumentNumber } from "../../utilities/utilities";
import { StatusCodesToString } from "../../schemas/ISLEntryStatusCodes";
import { SLCreateSLBatchContext } from "../../contexts/SLCreateSLBatchContext";
import { ISLEntryResponse } from "./SLCreateSchemas";

const SLCreateMetadata: React.FC = () => {
  const slCreateContext = useContext(SLCreateSLBatchContext);
  const [docNum, setDocNum] = useState<string | null>(null);
  const [jeStatus, setJeStatus] = useState<string | null>(null);

  useEffect(() => {
    if (slCreateContext.loadingStatus === SLLoadingStatus.Resolved) {
      if (slCreateContext.entry) {
        const entry = slCreateContext.entry as ISLEntryResponse;
        const docNum =
          entry.slDocNumber !== "" && entry.slDocNumber !== null
            ? entry.slDocNumber
            : entry.slEntryId !== 0
            ? leftPadDocumentNumber(entry.slEntryId)
            : null;
        setDocNum(docNum);
        if (entry.jeStatus && entry.jeStatus in StatusCodesToString) {
          setJeStatus(StatusCodesToString[entry.jeStatus as keyof typeof StatusCodesToString]);
        }
      } else {
        setDocNum(null);
        setJeStatus(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slCreateContext.loadingStatus, slCreateContext.entry]);
  return (
    <>
      {docNum === null ? null : (
        <Stack horizontal wrap tokens={{ childrenGap: 18 }}>
          <Stack.Item grow={2}>
            <Label htmlFor="slCreateDocumentNumberFromEntry">Name/Document Number</Label>
            <TextField id="slCreateDocumentNumberFromEntry" disabled value={docNum} />
          </Stack.Item>
          {!jeStatus ? null : (
            <Stack.Item>
              <Label htmlFor="slCreateJeStatusFromEntry">Status</Label>
              <TextField id="slCreateJeStatusFromEntry" disabled value={jeStatus} />
            </Stack.Item>
          )}
        </Stack>
      )}
    </>
  );
};

SLCreateMetadata.displayName = "SLCreateMetadata";

export default SLCreateMetadata;
